import { Conversation, Message } from '../types/conversations';

// Generate mock conversations for demonstration
export function generateMockConversations(): Conversation[] {
  const conversations: Conversation[] = [
    {
      id: '1',
      title: 'Recipe Recommendations',
      lastMessage: 'What ingredients do you have available?',
      lastMessageTime: new Date(Date.now() - 1000 * 60 * 30), // 30 minutes ago
      unreadCount: 2,
      messages: [
        {
          id: 'm1',
          role: 'user',
          content: 'Can you help me find a recipe for dinner?',
          timestamp: new Date(Date.now() - 1000 * 60 * 35)
        },
        {
          id: 'm2',
          role: 'assistant',
          content: 'I\'d be happy to help! What ingredients do you have available?',
          timestamp: new Date(Date.now() - 1000 * 60 * 30)
        }
      ]
    },
    {
      id: '2',
      title: 'Meal Planning',
      lastMessage: 'Here are some healthy breakfast options for next week...',
      lastMessageTime: new Date(Date.now() - 1000 * 60 * 60 * 2), // 2 hours ago
      messages: [
        {
          id: 'm3',
          role: 'user',
          content: 'I need help planning healthy breakfasts for next week',
          timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3)
        },
        {
          id: 'm4',
          role: 'assistant',
          content: 'Here are some healthy breakfast options for next week: overnight oats, smoothie bowls, avocado toast, and egg muffins. Would you like specific recipes for any of these?',
          timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2)
        }
      ]
    },
    {
      id: '3',
      title: 'Dietary Restrictions',
      lastMessage: 'Perfect! I\'ll focus on gluten-free options.',
      lastMessageTime: new Date(Date.now() - 1000 * 60 * 60 * 24), // Yesterday
      messages: [
        {
          id: 'm5',
          role: 'user',
          content: 'I have celiac disease and need gluten-free meal suggestions',
          timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 - 1000 * 60 * 5)
        },
        {
          id: 'm6',
          role: 'assistant',
          content: 'Perfect! I\'ll focus on gluten-free options. There are many delicious naturally gluten-free foods we can work with.',
          timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24)
        }
      ]
    },
    {
      id: '4',
      title: 'Quick Lunch Ideas',
      lastMessage: 'Try these 15-minute lunch recipes...',
      lastMessageTime: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2), // 2 days ago
      messages: [
        {
          id: 'm7',
          role: 'user',
          content: 'I need quick lunch ideas for work',
          timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2 - 1000 * 60 * 10)
        },
        {
          id: 'm8',
          role: 'assistant',
          content: 'Try these 15-minute lunch recipes: grain bowls, wraps, salads with protein, and leftover transformations.',
          timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2)
        }
      ]
    }
  ];

  return conversations;
}

// Format time for display
export function formatMessageTime(date: Date): string {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;
  if (hours < 24) return `${hours}h`;
  if (days < 7) return `${days}d`;
  
  return date.toLocaleDateString();
}

// Get conversation preview text
export function getConversationPreview(conversation: Conversation): string {
  if (conversation.messages.length === 0) return 'No messages yet';
  
  const lastMessage = conversation.messages[conversation.messages.length - 1];
  const maxLength = 60;
  
  if (lastMessage.content.length <= maxLength) {
    return lastMessage.content;
  }
  
  return lastMessage.content.substring(0, maxLength) + '...';
}

// Generate conversation title from messages
export function generateConversationTitle(messages: Message[]): string {
  if (messages.length === 0) return 'New Conversation';
  
  const firstUserMessage = messages.find(m => m.role === 'user');
  if (!firstUserMessage) return 'New Conversation';
  
  const words = firstUserMessage.content.split(' ').slice(0, 4);
  return words.join(' ') + (firstUserMessage.content.split(' ').length > 4 ? '...' : '');
}